import callApi from '@/utils/callApi';

const promises = {
  inventoryIds: null,
  inventory: null,
};

export const fetchInventory = async(hideDetails) => {
  const url = hideDetails ? '/v1/client/my-inventory?hideDetails=true' : '/v1/client/my-inventory';

  try {
    const res = await callApi('GET', url);
    if (res.status === 401) {
      return null;
    }
    
    const inventory = await res.json();
    return inventory;
  } catch (e) {
    return null;
  }
}

export const getMyInventory = async (hideDetails) => {  
  let promiseKey = 'inventory';
  if (hideDetails) {
    promiseKey = 'inventoryIds';
  }

  if (promises[promiseKey]) {
    return promises[promiseKey];
  }

  promises[promiseKey] = fetchInventory(hideDetails);

  const inventory = await promises[promiseKey];
  promises[promiseKey] = null;

  return inventory;
}

export default getMyInventory;